import React, { ReactElement, useEffect, useState } from 'react'
import Modal from './Modal'
import { PrimaryButton } from './Button'
import { InputLabel, TextInputWithLabel } from './Input'
import { observer } from 'mobx-react'
import { RoleSelector } from './RoleSelector'
import Radom, { IPermissionRole } from '../state/Radom'
import { errorToast, successToast } from '../util/Util'

interface IProps {
  visible: boolean
  isEditing: boolean
  userForm: ICreateUser
  onClose: () => void
  onRoleAssignment: () => void
  onUserFormUpdate: (u: Partial<ICreateUser>) => void
}

export interface ICreateUser {
  roles: IPermissionRole[]
  emailAddress?: string
}

const UserInviteModal = observer((props: IProps): ReactElement => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [apiRoles, setAPIRoles] = useState([] as IPermissionRole[])

  const listPermissionRoles = (): void => {
    if (!Radom.isLoggedIn) return
    Radom.listPermissionRoles()
      .then(roles => setAPIRoles(roles))
  }

  useEffect(() => {
    listPermissionRoles()
  }, [Radom.isLoggedIn])

  const onSubmitUser = async (): Promise<void> => {
    setIsSubmitting(true)
    try {
      await Radom.inviteMember({
        roles: props.userForm.roles.map(r => r.id),
        emailAddress: props.userForm.emailAddress && props.userForm.emailAddress.length > 0
          ? props.userForm.emailAddress.toLowerCase()
          : undefined
      })
      // props.onRoleAssignment()

      successToast(`Successfully ${props.isEditing ? 'updated' : 'invited'} user`)
      // props.onUserFormUpdate({
      //   roles: [],
      //   userAddr: ''
      // })
      props.onClose()
    } catch (err) {
      errorToast(err.reason || err.response?.data?.error || err.message)
      console.error('Failed to assign user to role', err)
    }
    setIsSubmitting(false)
  }

  return <Modal
    visible={props.visible}
    onClose={() => props.onClose()}
    title={props.isEditing ? 'Update user' : 'Invite team member'}>
    <form
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '300px',
        justifyContent: 'space-between'
      }}
      onSubmit={e => {
        e.preventDefault()
        e.stopPropagation()
      }}>
      <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'column', rowGap: 18 }}>
        <div style={{ fontSize: 14 }}>
          <TextInputWithLabel
            label='Email address'
            placeholder='Enter email address'
            disabled={props.isEditing || isSubmitting}
            required
            value={props.userForm.emailAddress}
            onChange={e => {
              const el = (e.target as HTMLInputElement)
              const value = el.value

              props.onUserFormUpdate({ emailAddress: value })
            }}
          />
        </div>
        <div style={{ fontSize: 14 }}>
          <InputLabel style={{ marginBottom: 10 }}>Roles</InputLabel>
          <RoleSelector
            onCloseFn={props.onClose}
            disabled={isSubmitting}
            roleCreationPage='/team/roles'
            roles={apiRoles}
            formatFunction={r => r.name}
            selectedRoles={props.userForm.roles}
            onSelectRole={r => props.onUserFormUpdate({
              roles: [...props.userForm.roles, r]
            })}
            onRemoveRole={roleId => props.onUserFormUpdate({
              roles: props.userForm.roles.filter(r => r !== roleId)
            })}
          />
        </div>
      </div>
      <div style={{ marginTop: 24, paddingTop: 18, borderTop: '1px solid #edf1f7' }}>
        <PrimaryButton
          style={{ width: '100%' }}
          disabled={isSubmitting}
          isLoading={isSubmitting}
          onClick={async () => await onSubmitUser()}>
          { props.isEditing ? 'Update' : 'Send invite' }
        </PrimaryButton>
      </div>
    </form>
  </Modal>
})

export default UserInviteModal
